import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'

//components
import {FountainLineItemGridComponent} from '../../components/Grids/FountainLineItemGrid.component';
import {LineTypeDropdownComponent} from '../../components/DomainData/LineTypeDropdown.component';
import {LineRunLocationDropdownComponent} from '../../components/DomainData/LineRunLocationDropdown.component';
import {FlavorMultiSelectComponent} from '../../components/DomainData/FlavorMultiSelect.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-fountaindetails',
  templateUrl: './FountainDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => FountainDetailsComponent)}]
})
export class FountainDetailsComponent extends BaseControlGroupComponent {

    @ViewChild(FountainLineItemGridComponent) public fountainLineItemGrid: FountainLineItemGridComponent;
    @ViewChild(LineTypeDropdownComponent) public lineTypeDropdownComponent: LineTypeDropdownComponent;
    @ViewChild(LineRunLocationDropdownComponent) public lineRunLocationDropdownComponent: LineRunLocationDropdownComponent;
    @ViewChild(FlavorMultiSelectComponent) public flavorMultiSelectComponent: FlavorMultiSelectComponent;

    fountainInfo: ent.FountainInfo = new ent.FountainInfo();
    removeReasonFilter: filters.ActivityReasonFilter;
    installReasonFilter: filters.ActivityReasonFilter;

    fountainDetailsForm: FormGroup;

    @Input() public showProjectedVolume: boolean;

    @Input() public requestTypeID: number;
    @Input() public showRemoveReason: boolean;
    @Input() public showInstallReason: boolean;
    @Input() public showFlavors: boolean;
    @Input() public requireLineType: boolean;
    @Input() public requireLineRunLength: boolean;
    @Input() public requireLineRunLocation: boolean;
    @Input() public requireNumberOfPumps: boolean;
    @Input() public requireNumberOfBIB2Racks: boolean;
    @Input() public requireNumberOfRegulators: boolean;
    @Input() public requireNumberOfCarbonators: boolean;
    @Input() public requireProjectedVolume: boolean;

    setDates(){}

    setRequestInfo(request: ent.Request){
      this.fountainInfo = request.FountainInfo;
      this.fountainLineItemGrid.lineItems = request.FountainLineItems;

      this.flavorMultiSelectComponent.selectedIDs = [];
      if (request.FountainInfo && request.FountainInfo.Flavors) {
        var flavorCodes = request.FountainInfo.Flavors.split(",");
        for (var fc of flavorCodes) {
            
          var flavor = this.flavorMultiSelectComponent.flavors.filter(x=>x.Code == fc)[0];
          if (flavor){
            this.flavorMultiSelectComponent.selectedIDs.push(flavor.ID);
          }
          
        }
    }
    }
    constructor(fb: FormBuilder) 
    { 
      super();  
      this.removeReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Fountain, EquipmentActivityID: enums.EquipmentActivityEnum.Remove};
      this.installReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Fountain, EquipmentActivityID: enums.EquipmentActivityEnum.Install};
      let group = {
          'removeReason' : '',
          'installReason' : '',
          'lineType' : '',
          'lineRunLength' : '',
          'lineRunLocation' : '',
          'numberOfPumps' : '',
          'numberOfBIB2Racks' : '',
          'numberOfRegulators' : '',
          'numberOfCarbonators' : '',
          'cabinetStand' : '',
          'legKit' : '',
          'flavors' : '',
          'projectedVolume' : ''
        };
        
        this.fountainDetailsForm = fb.group(group);

    }

    ngOnInit(): void {
        if(this.requireLineType) {
            this.fountainDetailsForm.controls['lineType'].setValidators(Validators.required);
        }

        if(this.requireLineRunLength) {
          this.fountainDetailsForm.controls['lineRunLength'].setValidators(Validators.required);
        }

        if(this.requireLineRunLocation) {
          this.fountainDetailsForm.controls['lineRunLocation'].setValidators(Validators.required);
        }

        if(this.requireNumberOfPumps) {
          this.fountainDetailsForm.controls['numberOfPumps'].setValidators(Validators.required);
        }

        if(this.requireNumberOfBIB2Racks) {
          this.fountainDetailsForm.controls['numberOfBIB2Racks'].setValidators(Validators.required);
        }

        if(this.requireNumberOfRegulators) {
          this.fountainDetailsForm.controls['numberOfRegulators'].setValidators(Validators.required);
        }

        if(this.requireNumberOfCarbonators) {
          this.fountainDetailsForm.controls['numberOfCarbonators'].setValidators(Validators.required);
        }

        if(this.requireProjectedVolume) {
          this.fountainDetailsForm.controls['projectedVolume'].setValidators(Validators.required);
        }
    }

    removeReasonChange(event: any){
        this.fountainInfo.RemoveReasonID = event;
    }

    installReasonChange(event: any){
        this.fountainInfo.InstallReasonID = event;
    }

    lineTypeChange(event: any){
        this.fountainInfo.LineTypeID = event;
    }

    lineRunLocationChange(event: any){
        this.fountainInfo.LineRunLocationID = event;
    }

    onLineItemsChanged(event: number){
        this.fountainDetailsForm.controls['removeReason'].clearValidators();
        this.fountainDetailsForm.controls['installReason'].clearValidators();
        this.fountainDetailsForm.controls['projectedVolume'].clearValidators();
        if (event > 0){
            if (this.showRemoveReason){
                this.fountainDetailsForm.controls['removeReason'].setValidators(Validators.required);
            }
            if (this.showInstallReason){
                this.fountainDetailsForm.controls['installReason'].setValidators(Validators.required);
            }
            if (this.requireProjectedVolume && this.showProjectedVolume){
              this.fountainDetailsForm.controls['projectedVolume'].setValidators(Validators.required);
            }
        }
        this.fountainDetailsForm.controls['removeReason'].updateValueAndValidity()
        this.fountainDetailsForm.controls['installReason'].updateValueAndValidity()
        this.fountainDetailsForm.controls['projectedVolume'].updateValueAndValidity()
    }

    getFlavors() : string {
      var flavors: string[] = [];
      for (var id of this.flavorMultiSelectComponent.selectedIDs) {
        var flavor = this.flavorMultiSelectComponent.flavors.filter(x=>x.ID == id)[0];
        if (flavor) {
          flavors.push(flavor.Code);
        }
      }
      var val = flavors.join(",");
      return val;
      
    }

}